<template>
    <div class="team" id="team">
      <div class="team__group">
        <template v-for="(team, index) in teams">
          <text-block
            :key="index"
            :title="team.title"
            :content="team.text"></text-block>
        </template>

      </div>
      <footer-part></footer-part>
    </div>
</template>

<script>
import TextBlock from "../components/TextBlock";
import Footer from "../layout/Footer";
export default {
  name: "Team",
  data: () => ({
    teams: []
  }),
  components: {
    TextBlock,
    'footer-part': Footer
  },
  created() {
    this.fetchData();
  },
  methods: {
    fetchData() {
      fetch('/pages/team')
        .then((response) => {
            return response.json();
        })
        .then((data) => this.teams = data);
    },
    handleScroll () {
          // Scroll fade
          let slidesTitle = document.getElementsByClassName("scrollFadeText");
          let slidesBody = document.getElementsByClassName("scrollFadeBody");


          for (let i = 0; i < slidesTitle.length; i++) {
              let elPos = slidesTitle[i].getBoundingClientRect().top
              if(elPos < 60) {
                  slidesTitle[i].style.opacity = (elPos / 200)
              } else {
                  slidesTitle[i].style.opacity = 1
              }
          }

          for (let i = 0; i < slidesBody.length; i++) {
              let elPos = slidesBody[i].getBoundingClientRect().top
              if(elPos < 60) {
                  slidesBody[i].style.opacity = (elPos / 200)
              } else {
                  slidesBody[i].style.opacity = 1
              }
          }
      }
  },
  mounted () {
    document.getElementById('team').addEventListener('scroll', this.handleScroll);
  }
}
</script>

<style scoped>

</style>
